import { forEach, forOwn, map } from 'lodash';

export const MonogramFontHelper = {};

MonogramFontHelper.load$ = function ( config ) {
    var d = Cx.Defer() ;
    var j = [];
    var model = { 
        "Match": {"Archived": false, "Owned":true, "Shared":true,
            "Tags":[{"Name":"/designer/" + config + "/Monogram",
            "Owned": true,
            "Shared": true,
            "Archived": false,
            "Type": "Font",
            "Links":null}]
        },
        "SortBy":"Name",
        "SortDir":"Asc" 
    } ;
    Cx.Core.Font.search$(model).then(function( fonts ) {
        var sub_j = { FamilyName: "", Styles: [] };
        forEach( fonts.Items, font => {
            //e.g. Stahls Mgram Circle Aviator 1 LTR
            var n = font.FullName.trim().split(/\s+/) ;
            if ( n.length >= 3 )
            {
                if  ( n[2] != sub_j.FamilyName ) {
                    if ( sub_j.Styles.length > 0 )
                        j.push(sub_j);
                    sub_j = { FamilyName: "", Styles: [] };
                    sub_j.FamilyName = n[2];
                }
            }
            if ( sub_j.Styles.indexOf(n[3]) == -1 )
                sub_j.Styles.push(n[3]);
        });
        if ( sub_j.Styles.length > 0 )
            j.push(sub_j);
        d.resolve(j);
    });
    return d;
};


/** WEBPACK FOOTER **
 ** ./src/cdl/util/monogram-font-helper.js
 **/